<template>
  <div id="app">
    <FundHeader />
    <div class="main">
      <router-view />
    </div>
    <FundFooter />
    <div id="components-back-top-demo-custom">
      <a-back-top>
        <div class="back-top" @mouseover="iconMouseOver" @mouseout="iconMouseOut"><a-icon type="vertical-align-top" :style="iconStyle"/></div>
      </a-back-top>
    </div>
  </div>
</template>

<script>
import FundHeader from "./components/header.vue";
import FundFooter from "./components/footer.vue";

export default {
  name: "App",
  components: {
    FundHeader,
    FundFooter,
  },
  data(){
    return{
      iconStyle:{fontSize: '28px', color: '#C1141E'}
    }
  },
  methods:{
    iconMouseOver(){
       this.iconStyle.color='#ffffff'
    },
    iconMouseOut(){
       this.iconStyle.color='#C1141E'

    }
  }
};
</script>
<style lang="scss">

* {
  padding: 0;
  margin: 0;
}
#app {
  width: 100%;
  overflow-x: hidden;
}
#components-back-top-demo-custom .ant-back-top {
  bottom: 100px;
}
.back-top{
  width: 54px;
  height: 54px;
  border-radius: 50%;
  border:  1.42px solid #c1141e;
  text-align: center;
  line-height: 66px;
  background: #fff;
  .action{
    &:hover{
      color:#ffffff;
    }
  }
  &:hover{
    background:#c1141e ;
  }
}
</style>
